import PropTypes from "prop-types";

import { buttonTracking } from "@lib/tracking.helpers";
import { Button } from "@transfr-inc/dashboard-components/forms";

import { PLAN_CREATION_FAILURE_REASONS } from "@features/budgeting-game/hooks/use-budget-game-state";

import "./plan-creation-failed.scss";

const COPY_BY_REASON = {
  [PLAN_CREATION_FAILURE_REASONS.lightcastNoData]: {
    title: "No salary data for this career",
    body: "We couldn't find salary data for this career and region. Try switching to a different region, or pick another career to explore.",
  },
  [PLAN_CREATION_FAILURE_REASONS.invalidInput]: {
    title: "Couldn't start the budget",
    body: "The salary we received wasn't valid. Try again or pick a different career.",
  },
  [PLAN_CREATION_FAILURE_REASONS.unknown]: {
    title: "Couldn't start the budget",
    body: "Something went wrong while starting the budget. Please try again.",
  },
};

export const PlanCreationFailedView = ({
  planCreationError,
  onRetry,
  onClose,
}) => {
  const reason =
    planCreationError?.reason ?? PLAN_CREATION_FAILURE_REASONS.unknown;
  const copy = COPY_BY_REASON[reason] ?? COPY_BY_REASON.unknown;

  return (
    <div className="plan-creation-failed" role="alert">
      <h2>{copy.title}</h2>
      <p>{copy.body}</p>
      <div className="plan-creation-failed-actions">
        <Button
          primary
          onClick={onRetry}
          {...buttonTracking("budget", "plan-creation-retry")}
        >
          Try again
        </Button>
        <Button
          onClick={onClose}
          {...buttonTracking("budget", "plan-creation-close")}
        >
          Close
        </Button>
      </div>
    </div>
  );
};

PlanCreationFailedView.displayName = "Plan Creation Failed View";

PlanCreationFailedView.propTypes = {
  planCreationError: PropTypes.shape({
    reason: PropTypes.string,
    message: PropTypes.string,
    status: PropTypes.number,
  }),
  onRetry: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
